import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function UINotifiSecondaryButton  
 * @param {STRING} text - Allows us to set the button text.
 * @param {STRING} icon - Allows us to set the button icon.
 * @param {FUNCTION} onClick - Allows us to set an event handler for the button when clicked.
 * @param {STRING} className - Allows us to pass a specific className to the button for primary and secondary buttons.
 * @param {STRING} data-point - Data point that should be applied to the button
 * @returns {React.Component}
 * @example
 * <UINotifiSecondaryButton className="primary-button some-class" onClick={() => this.handleClick()} text="Some text" data-point="point-name" />
 */

export default function UINotifiSecondaryButton(props) {
  const text = props.text ?? "[Button]";
  const icon = props.icon !== undefined ? (<SVGAsset id={props.icon} className="inline-text-icon left-icon" />) : (<></>);
  const className = props.className ?? "";
  const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";

  return (
    <button className={`ui-notifi-secondary-button flex-container flex-horizontal align-center ${className}`} data-point={point} onClick={props.onClick}>
      <span className="set-width">{icon}</span>
      <span className="flex-width">{text}</span>
    </button>
  );
}